var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-system-bar',{class:{ loaded: _vm.loaded },style:({'border-left-color': _vm.color}),attrs:{"status":""}},[_vm._t("toolbarTitle"),_c('v-spacer')],2),_c('v-card',{staticStyle:{"height":"64px"}},[_c('v-progress-linear',{staticClass:"ma-0",attrs:{"indeterminate":true,"active":!_vm.loaded,"color":_vm.color}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],class:[
        'title',
        'ml-2',
      {
        animated: _vm.loaded,
        fadeInRightCustom: _vm.loaded
      }]},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }